// ./src/contexts/ZonesContext/ZonesContext.tsx
//
// Thin context wrapper around the useEventZones hook. All derived data
// lives in the hook itself. See ZonesContext for the pattern.

import React, { createContext, useContext } from "react";

import {
  useEventZones,
  UseEventZonesOptions,
  UseEventZonesReturn,
} from "@/hooks/useEventZones";

const ZonesContext = createContext<UseEventZonesReturn | null>(null);

export interface ZonesProviderProps extends UseEventZonesOptions {
  children: React.ReactNode;
}

export const ZonesProvider: React.FC<ZonesProviderProps> = ({ children, ...options }) => {
  const value = useEventZones(options);

  return <ZonesContext.Provider value={value}>{children}</ZonesContext.Provider>;
};

export const useZonesContext = (): UseEventZonesReturn => {
  const context = useContext(ZonesContext);

  if (!context) {
    throw new Error(
      "useZonesContext must be used within a <ZonesProvider>. " +
        "Wrap your component tree with <ZonesProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalZonesContext = (): UseEventZonesReturn | null => {
  return useContext(ZonesContext);
};
